export default __webpack_public_path__ + "content/media/32.1429554a.jpg";